import Link from 'next/link';

export default function CallToAction() {
  return (
    <div className="bg-black text-white py-20 px-6 md:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
          Ready to Scale Your Organic Reach?
        </h2>
        <p className="text-lg md:text-xl text-white/70 mb-10 max-w-2xl mx-auto">
          Let's automate your UGC campaigns and drive real growth.
        </p>
        <Link
          href="http://calendly.com/aayushgupta-startupshell/30min?month=2025-04"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-white text-black font-bold py-4 px-8 hover:bg-gray-200 transition-colors text-lg md:text-xl"
        >
          Get Started
        </Link>
      </div>
    </div>
  );
}
